export const name = 'Nithin';
export const resumeLink = "https://drive.google.com/file/d/1AWub8Ez1RTJdendboxOmugddMhDH6_el/view?usp=drive_link";

export const EMAIL_JS_SERVICE_ID = process.env.REACT_APP_EMAIL_JS_SERVICE_ID;
export const EMAIL_JS_TEMPLATE_ID = process.env.REACT_APP_EMAIL_JS_TEMPLATE_ID;
export const EMAIL_JS_PUBLIC_KEY = process.env.REACT_APP_EMAIL_JS_PUBLIC_KEY;

export const experiences = [
    {
        'company': 'Amazon',
        'role': 'SDE Intern',
        'duration': 'Start Date: January 6',
        'logo': 'https://ardgowanhospice.org.uk/wp-content/uploads/2018/09/1920x1080-brands-amazon-logo.jpg',
        'points': [
            'Excited!',
        ],
        'url': 'https://www.amazon.in/',
    },
];